import React, { useEffect } from "react";

import CardProject from "../../components/CardProject/CardProject";
import DarkMode from "../../components/DarkMode/DarkMode";
import TabNavbar from "../../components/TabNav/TabNavbar";

import { tabProject as tab, projects } from "../data";

import "./Projects.css";

const Projects = () => {
	useEffect(() => {
		document.title = "Maish | Projects";
	}, []);

	return (
		<section id="main" className="projects-main">
			<DarkMode />
			<div className="container-fluid container-project">
				<TabNavbar tab={tab} color="orange" />
				<CardProject data={projects} tab={tab} />
			</div>
		</section>
	);
};

export default Projects;
